import { useEffect, useState } from "react";
import { TbHandFinger } from "react-icons/tb";
import { useTranslation } from "next-i18next";
import Cookies from "js-cookie";

import { Modal } from "@components/shared";
import { useMobileDetect } from "@hooks/useMobileDetect";

const COOKIE_NAME = "tutoHasShown";

export const VideoTuto = ({
  onOpen,
  onClose,
}: {
  onOpen?: () => void;
  onClose?: () => void;
}) => {
  const { t } = useTranslation();
  const { isMobile } = useMobileDetect();

  const [tutoHasShown, setTutoHasShown] = useState(true);

  useEffect(() => {
    const cookie = Cookies.get(COOKIE_NAME);
    if (!cookie) {
      onOpen && onOpen();
      setTutoHasShown(false);
    }
  }, []);

  const handleTutoClose = (e: React.MouseEvent) => {
    e.stopPropagation();
    Cookies.set(COOKIE_NAME, "true", {
      expires: new Date("9999-12-31"),
      path: "/",
    });
    setTutoHasShown(true);
    onClose && onClose();
  };

  return (
    <Modal isOpen={!tutoHasShown}>
      <div className="flex flex-col items-center w-full h-full" onClick={handleTutoClose}>
        <div className="relative w-full h-full">
          <div className="absolute flex flex-col items-center justify-center w-40 -translate-x-1/2 translate-y-1/2 top-1/2 left-1/2">
            <h3 className="mb-2 text-sm font-medium text-center text-gray-200">
              {t("VIDEO_TUTO_SWIPE")}
            </h3>
            <div className="mt-1 animate-moving-hand mr-14">
              <TbHandFinger size={32} className="text-gray-200" />
            </div>
          </div>
        </div>
        <button
          onClick={handleTutoClose}
          className="px-16 py-2 mx-0 mb-40 font-medium uppercase rounded-full bg-primary-color max-w-fit"
        >
          {t("GOT_IT")}!
        </button>
      </div>
    </Modal>
  );
};
